import { PositionsAccordion } from './PositionsAccordion'
import type { GroupedPosition } from '../types'
import { ErrorDisplay } from '@/components/common/error-display'
import { Skeleton } from '@/components/ui/skeleton'
import { cn } from '@/lib/utils'

export interface PositionsListProps {
  groupedPositions: Array<GroupedPosition>
  isLoading: boolean
  isError: boolean
  error: Error | null
  onViewQuestions: (positionId: string, positionTitle: string, positionLevel: string, positionRole: string) => void
  isRefetching?: boolean
  onRetry?: () => void
  className?: string
  openRole?: string
  openLevel?: string
  initialPositionId?: string
}

/**
 * Main positions list component (presentational).
 * Combines loading/error states with accordion display.
 */
export const PositionsList = ({
  groupedPositions,
  isLoading,
  isError,
  error,
  onViewQuestions,
  isRefetching,
  onRetry,
  className,
  openRole,
  openLevel,
  initialPositionId,
}: PositionsListProps) => {
  if (isLoading) {
    return (
      <div className={cn('space-y-4', className)}>
        {Array.from({ length: 3 }).map((_, i) => (
          <div key={i} className="p-6 bg-muted/30 rounded-lg space-y-4">
            {/* Role Title Skeleton */}
            <div className="flex items-center justify-between">
              <Skeleton className="h-7 w-32" />
              <Skeleton className="h-10 w-10 rounded-lg" />
            </div>
          </div>
        ))}
      </div>
    )
  }

  if (isError) {
    return (
      <div className={cn('space-y-6', className)}>
        <ErrorDisplay error={error} title="Error loading positions" variant="card" onRetry={onRetry} isRetrying={isRefetching} />
      </div>
    )
  }

  return (
    <div className={cn('space-y-6', className)}>
      <PositionsAccordion
        groupedPositions={groupedPositions}
        onViewQuestions={onViewQuestions}
        className="mt-6"
        initialOpenRole={openRole}
        initialOpenLevel={openLevel}
        initialPositionId={initialPositionId}
      />
    </div>
  )
}
